export const config = {
  // apiBaseUrl: "https://3wlwjj5k-3008.inc1.devtunnels.ms",
  // apiBaseUrl: "https://sskw3ghk-3091.inc1.devtunnels.ms",
  // apiBaseUrl: "https://3wlwjj5k-3008.inc1.devtunnels.ms",
  apiBaseUrl: "https://api.expandxpo.ai", // live
  // apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  // s3BucketURL: process.env.REACT_APP_S3_URL,
  s3BucketURL: "",
  secretKey: "niufdiudfiuwn",
};
